import React from 'react';

export default function ChatWindowPlaceholder() {
  return <div />;
}



// WEBPACK FOOTER //
// ./src/ChatWindowPlaceholder.js